var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeniusBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.001 9.10065C20.001 5.42083 22.9841 2.43774 26.6639 2.43774C30.3437 2.43774 33.3268 5.42083 33.3268 9.10065C33.3268 12.7805 30.3437 15.7636 26.6639 15.7636",
    stroke: "#62CE23",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 30.7566C20.001 34.4052 22.9841 37.363 26.6639 37.363C30.3437 37.363 33.3268 34.4052 33.3268 30.7566C33.3268 30.6458 33.3241 30.5357 33.3186 30.4263",
    stroke: "#62CE23",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3185 22.3946C34.9479 22.3946 37.8901 19.4252 37.8901 15.7624C37.8901 12.7927 35.9561 10.279 33.2899 9.43384",
    stroke: "#62CE23",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9828 20.7515C37.5594 21.7413 37.8901 22.8949 37.8901 24.1264C37.8901 27.8074 34.9358 30.7915 31.2914 30.7915C29.5342 30.7915 27.9374 30.0977 26.7548 28.9665",
    stroke: "#62CE23",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.10016C20 5.42034 17.0169 2.43726 13.3371 2.43726C9.65726 2.43726 6.67417 5.42034 6.67417 9.10016C6.67417 12.78 9.65726 15.7631 13.3371 15.7631",
    stroke: "#0D1580",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.7561C20 34.4047 17.0169 37.3625 13.3371 37.3625C9.65726 37.3625 6.67417 34.4047 6.67417 30.7561C6.67417 30.6453 6.67692 30.5352 6.68236 30.4258",
    stroke: "#0D1580",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68174 22.3946C5.05233 22.3946 2.11011 19.4252 2.11011 15.7624C2.11011 12.7927 4.04407 10.279 6.71025 9.43384",
    stroke: "#0D1580",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01743 20.751C2.44081 21.7408 2.11011 22.8944 2.11011 24.126C2.11011 27.8069 5.06444 30.791 8.70879 30.791C10.466 30.791 12.0628 30.0972 13.2454 28.966",
    stroke: "#0D1580",
    strokeWidth: 3.90968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9013 7.99341V33.0977",
    stroke: "#0D1580",
    strokeWidth: 3.90968
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeniusBar);
export default __webpack_public_path__ + "static/media/icon-genius-bar.8f7012f22fd5ee7b07f2c42cd15494c9.svg";
export { ForwardRef as ReactComponent };